module.exports = __webpack_public_path__ + "img/stukjes-appel-en-banaan.a8012153.jpg";